export const birthdays = {
  wanderer: [1, 3],
  jahoda: [1, 5],
  lan_yan: [1, 6],
  thoma: [1, 9],
  chevreuse: [1, 10],
  sandrone: [1, 13],
  columbina: [1, 14],
  diona: [1, 18],
  citlali: [1, 20],
  kirara: [1, 22],
  rosaria: [1, 24],
  lynette: [2, 2],
  lyney: [2, 2],
  vesna: [2, 4],
  alyosha: [2, 9],
  alhaitham: [2, 11],
  beidou: [2, 14],
  varka: [2, 17],
  odette: [2, 20],
  sangonomiya_kokomi: [2, 22],
  bennett: [2, 29],
  lauma: [3, 1],
  qiqi: [3, 3],
  yaoyao: [3, 6],
  shenhe: [3, 10],
  xilonen: [3, 13],
  durin: [3, 14],
  jean: [3, 14],
  yumemizuki_mizuki: [3, 16],
  noelle: [3, 21],
  ifa: [3, 23],
  kamisato_ayato: [3, 26],
  vodyanitsa: [3, 29],
  sigewinne: [3, 30],
  ineffa: [4, 2],
  lohen: [4, 3],
  aloy: [4, 4],
  dehya: [4, 7],
  charlotte: [4, 10],
  xianyun: [4, 11],
  xiao: [4, 17],
  yelan: [4, 20],
  kachina: [4, 22],
  baizhu: [4, 25],
  diluc: [4, 30],
  candace: [5, 3],
  collei: [5, 8],
  nefer: [5, 9],
  zibai: [5, 15],
  gorou: [5, 18],
  yun_jin: [5, 21],
  linnea: [5, 23],
  dahlia: [5, 25],
  fischl: [5, 27],
  sethos: [5, 31],
  arataki_itto: [6, 1],
  paimon: [6, 1],
  escoffier: [6, 8],
  lisa: [6, 9],
  venti: [6, 16],
  yoimiya: [6, 21],
  cyno: [6, 23],
  raiden_shogun: [6, 26],
  yae_miko: [6, 27],
  barbara: [7, 5],
  kaveh: [7, 9],
  kujou_sara: [7, 14],
  hu_tao: [7, 15],
  tartaglia: [7, 20],
  shikanoin_heizou: [7, 24],
  klee: [7, 27],
  kuki_shinobu: [7, 27],
  yanfei: [7, 28],
  mualani: [8, 3],
  iansan: [8, 8],
  amber: [8, 10],
  mika: [8, 11],
  navia: [8, 16],
  chiori: [8, 17],
  faruzan: [8, 20],
  arlecchino: [8, 22],
  ningguang: [8, 26],
  mavuika: [8, 28],
  mona: [8, 31],
  chongyun: [9, 7],
  razor: [9, 9],
  albedo: [9, 13],
  clorinde: [9, 20],
  aino: [9, 21],
  emilie: [9, 22],
  freminet: [9, 24],
  kamisato_ayaka: [9, 28],
  nicole: [9, 29],
  xingqiu: [10, 9],
  furina: [10, 13],
  ororon: [10, 14],
  xinyan: [10, 16],
  sayu: [10, 19],
  eula: [10, 25],
  nahida: [10, 27],
  kaedehara_kazuha: [10, 29],
  flins: [10, 31],
  xiangling: [11, 2],
  skirk: [11, 5],
  kinich: [11, 11],
  varesa: [11, 15],
  keqing: [11, 20],
  prune: [11, 20],
  wriothesley: [11, 23],
  sucrose: [11, 26],
  kaeya: [11, 30],
  ganyu: [12, 2],
  nilou: [12, 3],
  chasca: [12, 10],
  neuvillette: [12, 18],
  layla: [12, 19],
  dori: [12, 21],
  gaming: [12, 22],
  illuga: [12, 23],
  tighnari: [12, 29],
  zhongli: [12, 31],
};
